import React, { useCallback } from 'react';

import { PaginatedEntityTable } from 'components/common';
import type { Sort } from 'stores/PaginationTypes';

import { fetchDataLakeRetrievals, keyFn } from './useDataLakeRetrievals';
import type { DataLakeRetrievalResult } from './useDataLakeRetrievals';
import customColumnRenderers from './list-components/customColumnRenderers';
import DataLakeRetrievalActions from './DataLakeRetrievalActions';

export const COLUMNS_ORDER = ['retrieved_at', 'source_name', 'status', 'timestamp_from', 'timestamp_to', 'retrieved_documents', 'stream_title', 'index_failures', 'restore_indices'];

export const DEFAULT_LAYOUT = {
  entityTableId: 'retrievals',
  defaultPageSize: 20,
  defaultSort: { attributeId: 'retrieved_at', direction: 'desc' } as Sort,
  defaultDisplayedAttributes: COLUMNS_ORDER,
};

const DataLakeRetrievalsList = () => {
  const retrievalActions = useCallback(
    (retrieval: DataLakeRetrievalResult) => <DataLakeRetrievalActions retrieval={retrieval} />,
    [],
  );

  return (
    <PaginatedEntityTable<DataLakeRetrievalResult>
      humanName="retrievals"
      columnsOrder={COLUMNS_ORDER}
      entityActions={retrievalActions}
      tableLayout={DEFAULT_LAYOUT}
      fetchEntities={fetchDataLakeRetrievals}
      keyFn={keyFn}
      columnRenderers={customColumnRenderers}
      entityAttributesAreCamelCase={false}
      searchPlaceholder="Search for retrieval"
      fetchOptions={{ refetchInterval: 5000 }}
    />
  )
};

export default DataLakeRetrievalsList;
